import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { KeretService } from 'src/app/keret.service';

/**
 *  KONRÁD NYUSZI BEÁLLÍTÁSA (intézményenként).
 *
 *  A segéd alapból ki van kapcsolva. Két üzemmód:
 *    - HELYI MODELL (Ollama): az iskola saját gépén fut, a személyes adat nem hagyja el a
 *      rendszert. Kell hozzá egy gép, amin az Ollama fut, és amit a SULINFORM szervere elér.
 *    - CLAUDE (Anthropic API): ha nincs megfelelő gép. A kérdések és a hozzájuk lekért saját
 *      adatok (pl. órarend) az Anthropic szerverére mennek – ezt az iskolának vállalnia kell.
 *  A „Próba” gomb egy rövid kérdéssel ellenőrzi, hogy a modell elérhető-e.
 */
@Component({
  selector: 'app-admin-konrad-beallitas',
  templateUrl: './konrad-beallitas.component.html',
  styleUrls: ['./konrad-beallitas.component.scss'],
})
export class AdminKonradBeallitasComponent implements OnInit {
  toltodik = true;
  ment = false;
  proba = false;
  intezmeny = '';
  b: any = { bekapcsolva: false, folyamatos: true, szolgaltato: 'ollama', ollama_url: '', ollama_modell: '', claude_modell: '' };
  alap: any = {};
  vanKulcs = false;
  kulcs = '';
  torolKulcs = false;
  uzenet: { ok: boolean; szoveg: string } | null = null;

  constructor(private http: HttpClient, private data: DataService, private keret: KeretService) {}

  /** Az adminjogot az aktuális alrendszer (SULINFORM / Könyvelés / Bér) jogkörei szerint nézi a kiszolgáló. */
  private get modQ(): string { return `?mod=${encodeURIComponent(this.keret.a?.aktualisMod() || 'SULINFORM')}`; }

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny').catch(() => null);
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    await this.betolt();
  }

  async betolt() {
    this.toltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/konrad/beallitas/${this.intezmeny}${this.modQ}`));
      this.b = { bekapcsolva: !!r.bekapcsolva, folyamatos: r.folyamatos !== false, szolgaltato: r.szolgaltato || 'ollama', ollama_url: r.ollama_url || '',
        ollama_modell: r.ollama_modell || '', claude_modell: r.claude_modell || '' };
      this.alap = r.alap || {};
      this.vanKulcs = !!r.van_claude_kulcs;
    } catch (e: any) {
      this.uzenet = { ok: false, szoveg: e?.error?.error || 'A beállítás nem tölthető be.' };
    } finally { this.toltodik = false; }
  }

  async mentes() {
    this.ment = true; this.uzenet = null;
    try {
      await firstValueFrom(this.http.put(`/api/konrad/beallitas/${this.intezmeny}${this.modQ}`,
        { ...this.b, claude_kulcs: this.kulcs || undefined, torol_kulcs: this.torolKulcs }));
      this.kulcs = ''; this.torolKulcs = false;
      this.uzenet = { ok: true, szoveg: 'Elmentve.' };
      await this.betolt();
    } catch (e: any) {
      this.uzenet = { ok: false, szoveg: e?.error?.error || 'Nem sikerült menteni.' };
    } finally { this.ment = false; }
  }

  async probal() {
    this.proba = true; this.uzenet = null;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/konrad/teszt/${this.intezmeny}${this.modQ}`, {}));
      this.uzenet = { ok: true, szoveg: `A modell válaszolt (${Math.round(r.ido_ms / 100) / 10} mp): „${r.valasz}”` };
    } catch (e: any) {
      this.uzenet = { ok: false, szoveg: e?.error?.error || 'A modell nem érhető el.' };
    } finally { this.proba = false; }
  }
}
